export enum AppMode {
  NOTIFICATIONS = 'NOTIFICATIONS',
  READONLY = 'READONLY',
  RAW = 'RAW',
  WAITING_FOR_OFFER = 'WAITING_FOR_OFFER',
  WAITING_FOR_OFFER_LOADING = 'WAITING_FOR_OFFER_LOADING',
}
